import { render, staticRenderFns } from "./UsersBisnisUnitCreate.vue?vue&type=template&id=96be824e&lang=pug"
import script from "./UsersBisnisUnitCreate.vue?vue&type=script&lang=js"
export * from "./UsersBisnisUnitCreate.vue?vue&type=script&lang=js"
import style0 from "./UsersBisnisUnitCreate.vue?vue&type=style&index=0&id=96be824e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports